import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const ChecklistSucDec: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29816)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.10418 13.226C11.1381 13.226 12.7862 14.967 12.7862 17.1135C12.7862 19.2609 11.1373 21.0009 9.10418 21.0009C7.07021 21.0009 5.42211 19.26 5.42211 17.1135C5.42124 14.967 7.07021 13.226 9.10418 13.226ZM11.319 14.7752C10.0956 13.4836 8.11196 13.4836 6.88851 14.7752C5.6652 16.0667 5.6652 18.1611 6.88851 19.4527C8.11182 20.7443 10.0955 20.7443 11.319 19.4527C12.5423 18.1612 12.5423 16.0669 11.319 14.7752ZM10.2315 15.5132L9.10329 16.7043L7.97513 15.5132C7.86785 15.3999 7.69396 15.3999 7.58668 15.5132C7.4794 15.6265 7.4794 15.81 7.58668 15.9233L8.71484 17.1144L7.58668 18.3055C7.4794 18.4188 7.4794 18.6023 7.58668 18.7156C7.69396 18.8289 7.86784 18.8289 7.97513 18.7156L9.10329 17.5245L10.2315 18.7156C10.3387 18.8289 10.5126 18.8289 10.6199 18.7156C10.7272 18.6023 10.7272 18.4188 10.6199 18.3055L9.49174 17.1144L10.6199 15.9233C10.7272 15.81 10.7272 15.6265 10.6199 15.5132C10.5126 15.3999 10.3387 15.3999 10.2315 15.5132ZM9.10418 4.17052C11.1381 4.17052 12.7862 5.91146 12.7862 8.05796C12.7862 10.2054 11.1373 11.9454 9.10418 11.9454C7.07021 11.9454 5.42211 10.2045 5.42211 8.05796C5.42124 5.91055 7.07021 4.17052 9.10418 4.17052ZM11.319 5.71874C10.0956 4.42719 8.11196 4.42719 6.88851 5.71874C5.6652 7.01028 5.6652 9.10461 6.88851 10.3963C8.11182 11.688 10.0955 11.6878 11.319 10.3963C12.5423 9.10475 12.5423 7.01042 11.319 5.71874ZM7.24332 8.31917L8.31871 9.45454C8.42599 9.5678 8.59987 9.5678 8.70716 9.45454L10.9642 7.07157C11.0715 6.9583 11.0715 6.77472 10.9642 6.66145C10.857 6.54818 10.6831 6.54819 10.5758 6.66145L8.51241 8.83991L7.63082 7.90915C7.52354 7.79589 7.34965 7.79589 7.24237 7.90915C7.13596 8.0215 7.13604 8.2059 7.24332 8.31917ZM13.8626 7.15093C13.7112 7.15093 13.5875 7.02122 13.5875 6.86137C13.5875 6.70153 13.7104 6.57182 13.8626 6.57182H18.3044C18.4558 6.57182 18.5795 6.70153 18.5795 6.86137C18.5795 7.02122 18.4566 7.15093 18.3044 7.15093H13.8626ZM13.8626 9.54489C13.7112 9.54489 13.5875 9.41519 13.5875 9.25443C13.5875 9.09458 13.7104 8.96396 13.8626 8.96396H16.0834C16.2348 8.96396 16.3585 9.09366 16.3585 9.25443C16.3585 9.41427 16.2357 9.54489 16.0834 9.54489H13.8626ZM13.8626 16.2072C13.7112 16.2072 13.5875 16.0775 13.5875 15.9177C13.5875 15.7578 13.7104 15.6281 13.8626 15.6281H18.3044C18.4558 15.6281 18.5795 15.7578 18.5795 15.9177C18.5795 16.0775 18.4566 16.2072 18.3044 16.2072H13.8626ZM13.8626 18.6012C13.7112 18.6012 13.5875 18.4715 13.5875 18.3107C13.5875 18.1509 13.7104 18.0212 13.8626 18.0212H16.0834C16.2348 18.0212 16.3585 18.1509 16.3585 18.3107C16.3585 18.4705 16.2357 18.6012 16.0834 18.6012H13.8626ZM6.30381 1C5.03636 1 4 2.09426 4 3.43231V20.5677C4 21.9058 5.03645 23 6.30381 23H17.6962C18.9636 23 20 21.9057 20 20.5677V5.08012C20 5.00613 19.9732 4.93123 19.9195 4.8746L16.3318 1.08677C16.2816 1.0338 16.2124 1 16.1363 1L6.30379 1.00091L6.30381 1ZM15.861 1.58002H6.30381C5.34003 1.58002 4.54929 2.41395 4.54929 3.4324V20.5678C4.54929 21.5853 5.33917 22.4202 6.30381 22.4202H17.6962C18.66 22.4202 19.4507 21.5862 19.4507 20.5678V5.3697H16.1354C15.984 5.3697 15.8612 5.23999 15.8612 5.08014L15.861 1.58002ZM19.062 4.78982H16.4103V1.99016L19.062 4.78982Z'
          fill='url(#paint0_linear_12280_29816)'
          stroke='url(#paint1_linear_12280_29816)'
          strokeWidth='0.7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29816'
          x1='7.31323'
          y1='2.50015'
          x2='19.0202'
          y2='19.5649'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29816'
          x1='7.31323'
          y1='2.50015'
          x2='19.0202'
          y2='19.5649'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29816'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChecklistSucDec;
